import { Card as MuiCard, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

export const Card = ({ heading, value, icon }) => {
  const t = useTranslations();
  return (
    <MuiCard sx={{ width: "100%", maxWidth: "17.85rem" }} elevation={1}>
      <div className="flex justify-between">
        <Typography fontSize="1rem" variant="body1">
          {t(heading)}
        </Typography>
        {icon}
      </div>
      <Typography fontWeight={700} variant="h3">
        {value}
      </Typography>
    </MuiCard>
  );
};

export default Card;
